import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory} from 'react-router-dom/cjs/react-router-dom.min';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import './newsById.css'




const NewsById = () => {
    const history = useHistory();
    const { newsId } = useParams();
    const [isLoaded, setIsLoaded] = useState();
  
    const backClick = () => {
        history.goBack()
    }
  
    useEffect(() => {
        const fetchNews = async () => {
            try{
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/news/${newsId}`);
                const responseData = await response.json();
                setIsLoaded(responseData.news)
            } catch (err) {
                console.log(err)
            }
            
        };
        fetchNews();
    }, [newsId])

    if (!isLoaded) {
        return (
            <main>
                <h1>Article not found</h1>   
                <Link to='/'>Back to main page</Link>
            </main>
        )
    }


    return (
        <main className='main-announce-container'>
             <FontAwesomeIcon icon={faArrowLeft} className='font-controller-announce' onClick={backClick}/>
            <div className='announce-container'>
                <h1>{isLoaded.title}</h1>
                <div className='announce-img-container'>
                    <img 
                      src={`${process.env.REACT_APP_ASSET_URL}/${isLoaded.image}`} 
                      alt={isLoaded.name}
                    />
                </div>
                <div className='announce-url'>
                    <a href={isLoaded.url}>Мэдээний Link</a>
                    <div>Нийтэлсэн: {new Date(isLoaded.createdAt).toLocaleDateString()}</div>
                </div>
                <div className='announce-content'>
                    {isLoaded.content}
                </div>
            
            </div>
          
        </main>
    )
}
export default NewsById;